import { render, staticRenderFns } from "./FormItemInput.vue?vue&type=template&id=26e980b8"
import script from "./FormItemInput.vue?vue&type=script&lang=ts"
export * from "./FormItemInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports